import { Badge, Grid, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { ScopeGuard } from '../../../reusable-components/scopes';
import { useHeaderItems } from '../headerItems';

export default function Navbar() {
  const { pathname } = useLocation();
  const paths = [];

  const { invoiceSubitems, adminSubitems, ticketSubitems, contractSubitems, superAdminSubitems, rentalSubitems, transportSubitems } =
    useHeaderItems();
  const pathObject = pathname.includes('invoicing')
    ? invoiceSubitems
    : pathname.includes('rentals')
    ? rentalSubitems
    : pathname.includes('super-admin')
    ? superAdminSubitems
    : pathname.includes('admin')
    ? adminSubitems
    : pathname.includes('transports')
    ? transportSubitems
    : pathname.includes('ticket')
    ? ticketSubitems
    : pathname.includes('contract')
      ? contractSubitems
    : paths;

  const HeaderItem = ({ index, path }) => (
    <Badge
      key={index}
      badgeContent={path.badgeContent}
      invisible={!path.badgeContent}
      color="info"
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      max={999}
      sx={{
        '& .MuiBadge-badge': {
          right: 22,
          top: -3,
          border: '2px solid #fff',
          padding: '0 4px',
        },
      }}
    >
      <Typography
        key={index}
        sx={{
          mr: 2,
          textDecoration: path.textDecoration,
          cursor: 'pointer',
        }}
        variant="subtitle2"
        color={path.color}
        onClick={() => {
          if (path.onClick) path.onClick();
        }}
      >
        {path.label}
      </Typography>
    </Badge>
  );

  return (
    <Grid item xs={12}>
      <Grid container direction="row" justifyContent="space-between" alignItems="center">
        <Grid container direction="row" justifyContent="flex-start" alignItems="center">
          {pathObject?.map((path, index) =>
            path?.scopes?.length ? (
              <ScopeGuard scopes={path.scopes} allowAdmin={path.allowAdmin} key={path.label}>
                <HeaderItem index={index} path={path} />
              </ScopeGuard>
            ) : (
              <HeaderItem key={path.label} index={index} path={path} />
            )
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}
